import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import Translate from 'client/components/translate';
import { isActiveCrossSell } from 'client/utils/ifpCrossSell';
import 'client/styles/crossSell.scss';

const mapStateToProps = (state, ownProps) => ({
  shouldShowBar: isActiveCrossSell(state, ownProps.route.appType),
});

const propTypes = {
  shouldShowBar: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired,
  route: PropTypes.shape({
    appType: PropTypes.string.isRequired,
  }).isRequired,
};

class CrossSellContainer extends PureComponent {
  render() {
    const { shouldShowBar, children } = this.props;

    return (
      <div className={cx('cross-sell-container', { 'bar-visible': shouldShowBar })}>
        {shouldShowBar && (
          <div className="bar-container">
            <div className="bar flex-row">
              <a href="/cart" className="text-v-middle">
                <span className="icon-left-open-mini v-middle" />
                <Translate path="common.cta.backToCart" className="v-middle" />
              </a>
            </div>
          </div>
        )}
        {children}
      </div>
    );
  }
}
CrossSellContainer.propTypes = propTypes;

export default connect(mapStateToProps)(CrossSellContainer);
